<template>
    <b-form-row>
       
        <b-col cols="12" class="mt-3 dd" v-if="masterItem.value_type === 'Dropdown Selection'">
        <div v-if="masterItem.multiple_selection_allowed">
                                                    
                          
            <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
          
              <multiselect id="input-order_type" :placeholder="$translate('select_activity_type')" 
            v-model="taskValueArray" 
           :options="formattedOptions"
            :searchable="true"
            :limit="2"
            :multiple="true" 
            :preserve-search="true"
            :selectLabel="selectLabel" 
            label="label" 
            track-by="id"  :close-on-select="true">
               
            </multiselect>
          
            
      
        
    </div>
   
    <div v-else>
      
        <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
        <b-form-select
        class="form-control"
            id="input-default_value_select"
            v-model="itemModel.task_value"
            :options="value_selections"
            
        >
            <template #first>
                <b-form-select-option :value="null" disabled
                    >Select Default Value</b-form-select-option
                >
            </template>
        </b-form-select>
    </div>
    </b-col>
    <b-col cols="12" class="mt-3" v-else-if="masterItem.value_type === 'Date Selection'">
        <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
        <b-form-input
            type="date"
            id="input-date_value"
            v-model="itemModel.task_value"
         
            placeholder="Select Date"
        />
    </b-col>
    <b-col cols="12" v-else-if="masterItem.value_type === 'Numeric Value'">
       
        <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
                <b-form-input
                  
                    type="number"
                    id="input-numeric_value"
                    v-model="itemModel.task_value"
                  
                    placeholder="Enter Numeric Value"
                ></b-form-input>
       
    
    </b-col>
    <b-col cols="12" v-else-if="masterItem.value_type === 'Free Text'">
       
        <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
                <b-form-input
                  
                    type="text"
                    id="input-numeric_value"
                    v-model="itemModel.task_value"
                  
                    placeholder="Enter Text"
                ></b-form-input>
       
    
    </b-col>
        <!-- <b-col cols="12" :class="{ 'dd': !!is_selection_value_type }">
            <label class="mb-3"><strong>{{ value_name || $translate('value') }}</strong></label>
            <b-form-select  @change="complete_task()" v-if="!!is_selection_value_type" id="TaskValue" class="form-control"
                v-model="itemModel.task_value" :options="value_selections" :disabled="disabled">
                <template #first>
                    <b-form-select-option :value="null" disabled>
                        {{ $translate('select_value') }}
                    </b-form-select-option>
                </template>
            </b-form-select>
            <b-form-input v-else  @change="complete_task()" id="TaskValue" name="TaskValue" :placeholder="$translate('enter_value')"
                type="number" :min="value_min || 0" :max="value_max || 1000" step="any" v-model="itemModel.task_value"
                :readonly="disabled" />
        </b-col> -->

        <b-col cols="12" class="mt-3">
            <label class="mb-3" for="TaskNotes"><strong>{{ $translate('notes') }}</strong></label>
            <!-- <b-form-textarea class="" id="TaskNotes" name="TaskNotes" :placeholder="$translate('enter_notes')"
                v-model="itemModel.task_notes" :readonly="disabled" /> -->
                <textarea-with-audio 
                    v-model="itemModel.task_notes" 
                    :idAttr="'TaskNotes'"
                    :placeholderAttr="$translate('enter_notes')" 
                    :rows="6" 
                    :maxRows="10"
                    :disabledAttr="disabled"
                />
        </b-col>
        <b-col cols="6" class="mt-2 mb-3 pt-2 ps-1 d-flex align-items-center">
            <div class="form-check me-2">
                <label class="form-check-label">
                    <input type="checkbox" id="task-check" class="form-check-input" v-model="itemModel.task_checked"
                        name="taskChecked" :value="1" :unchecked-value="0" :disabled="disabled" />
                    <i class="input-helper"></i>
                </label>
            </div>
            <label for="task-check" class="mb-0"><strong>{{ $translate('completed') }}</strong></label>
        </b-col>
    </b-form-row>
</template>
<script>
import TextareaWithAudio from '@/components/TextareaWithAudio.vue'
import Multiselect from 'vue-multiselect'
export default {
    name: 'orders-ViewTask',

    components: {'textarea-with-audio': TextareaWithAudio,Multiselect},
    props: ['value', 'masterItem', 'disabled'],

    computed: {
        value_name() {
            console.log('masterItem', this.masterItem)
            return this.masterItem && this.masterItem.value_name
        },
        value_selections() {
            try {
                const _selections = JSON.parse(
                    this.masterItem && this.masterItem.value_selections
                )
                if (!Array.isArray(_selections)) throw new Error('Not Array')
                return _selections
            } catch (err) {
                return []
            }
        },
        value_max() {
            return (this.masterItem && this.masterItem.value_max) || 1000
        },
        value_min() {
            return (this.masterItem && this.masterItem.value_min) || 0
        },
        default_value() {
            return (this.masterItem && this.masterItem.default_value) || null
        },
        is_selection_value_type() {
            return !!(
                this.masterItem && this.masterItem.is_selection_value_type
            )
        },
      
        itemModel: {
            get() {
                return this.value
            },

            set(_value) {
                this.$emit('input', _value)
            },
        },
        formattedOptions() {
            const _selections = JSON.parse(
                    this.masterItem && this.masterItem.value_selections
                )
                if (!Array.isArray(_selections)) throw new Error('Not Array')
        // Transform the original string array into objects with 'id' and 'label'
        return _selections.map((item, index) => ({
            id: item,  // Generate a unique ID based on the index
            label: item     // Use the string as the label
        }));
       },
       selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        taskValueArray: {
            get() {
                // Convert the comma-separated string to an array of objects from formattedOptions
                if (!this.itemModel.task_value) return []
                
                const selectedValues = this.itemModel.task_value.split(',').map(val => val.trim())
                
                // Map the split string values to corresponding objects in formattedOptions
                return this.formattedOptions.filter(option => selectedValues.includes(option.id))
            },
            set(selectedOptions) {
                // Convert the array of selected objects back to a comma-separated string of their ids
                const selectedValues = selectedOptions.map(option => option.id)
                this.itemModel.task_value = selectedValues.join(',')
            },
        },
    },
    watch: {
            'itemModel.task_notes': function(val) {
                this.complete_task();
            }
    },
    methods:{
        complete_task(){
            this.itemModel.task_checked = true;
        }
    }
}
</script>
